var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.445 20.2987C11.3342 20.2987 11.2252 20.2703 11.1285 20.2161C9.15967 19.0629 7.31189 17.7145 5.61306 16.1914C1.88846 12.8393 0 9.49871 0 6.26236C0.00038358 4.92285 0.43014 3.61875 1.22619 2.54145C2.02224 1.46415 3.14266 0.67039 4.423 0.276685C5.70334 -0.11702 7.07617 -0.0899412 8.33999 0.353948C9.6038 0.797837 10.6921 1.63516 11.445 2.74301C12.1979 1.63516 13.2862 0.797837 14.55 0.353948C15.8138 -0.0899412 17.1867 -0.11702 18.467 0.276685C19.7473 0.67039 20.8678 1.46415 21.6638 2.54145C22.4599 3.61875 22.8896 4.92285 22.89 6.26236C22.89 9.49871 21.0015 12.8393 17.2769 16.1914C15.5781 17.7145 13.7303 19.0629 11.7615 20.2161C11.6648 20.2703 11.5558 20.2987 11.445 20.2987Z",
    fill: "#FCC436"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHeartIcon);
export default __webpack_public_path__ + "static/media/blackHeartIcon.8185535530e562ce67c1516a742182db.svg";
export { ForwardRef as ReactComponent };